<script setup lang="ts">
import UiChip from '../ui/UiChip.vue';
import PartnerIcon from './PartnerIcon.vue';
import { computed } from 'vue';

interface Props {
    name: string;
    url?: string;
    iconUrl?: string;
    size?: 'xs' | 'sm' | 'md';
    rounded?: 'normal' | 'full' | 'small';
    responsive?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
    name: '',
    url: undefined,
    iconUrl: undefined,
    size: 'md',
    rounded: 'normal',
    responsive: false,
});

const partnerIconSize = computed(() => {
    return props.size === 'xs' ? 'sm' : props.size === 'sm' ? 'md' : 'md';
});

const chipSize = 'md';

</script>

<template>
    <UiChip :text="props.name" variant="default" :size="chipSize" :rounded="props.rounded" :textClass="{
        'hidden md:block': props.responsive,
    }">
        <template #before>
            <div v-if="props.iconUrl" class="flex items-stretch">
                <PartnerIcon 
                class="-my-0.25"
                :src="props.iconUrl" :size="partnerIconSize" :override-rounding="true" rounded-side="left" :class="{
                    '-translate-x-0.25': !props.responsive,
                    'rounded-l-md': props.rounded === 'normal',
                    'rounded-l-lg': props.rounded === 'full',
                    'rounded-l-sm': props.rounded === 'small',
                    'max-sm:rounded-r-md': props.responsive && props.rounded === 'normal',
                    'max-sm:rounded-r-lg': props.responsive && props.rounded === 'full',
                    'max-sm:rounded-r-sm': props.responsive && props.rounded === 'small',
                }" />
            </div>
            <slot name="before" />
        </template>
        <template #inline-before>
            <slot name="inline-before" />
        </template>
        <template #inline-after>
            <slot name="inline-after" />
        </template>
        <template #after>
            <slot name="after" />
        </template>
    </UiChip>
</template>


